import React from 'react';
import { AmplifyAuthenticator, AmplifySignIn, AmplifyForgotPassword } from '@aws-amplify/ui-react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  amplifyAuthenticator: {
    textAlign: 'center'
  }
});

function Authenticator() {
  const classes = useStyles();
  return (
    <>
      {process.env.REACT_APP_STAGE === 'dev' || process.env.REACT_APP_STAGE === 'dev.local' || process.env.REACT_APP_STAGE === 'stg'
        ? process.env.REACT_APP_STAGE
        : ''}
      <AmplifyAuthenticator className={classes.amplifyAuthenticator}>
        <AmplifySignIn
          hideSignUp={true}
          slot="sign-in"
          formFields={[
            {
              type: 'email',
              required: true
            },
            {
              type: 'password',
              required: true
            }
          ]}
        ></AmplifySignIn>
        <AmplifyForgotPassword slot="forgot-password" usernameAlias="email"></AmplifyForgotPassword>
      </AmplifyAuthenticator>
    </>
  );
}

export default Authenticator;
